import { Moment } from 'moment';
import { IEvent } from './event.model';

export interface ISession {
  id?: number;
  startTime?: Moment;
  enabled?: boolean;
  event?: IEvent;
}

export const defaultValue: Readonly<ISession> = {
  enabled: false
};
